export default {
  methods: {
    async onDetil() {
      this.$set(this, 'formulir', {});

      await this.getProfil();

      this.$set(this.formulir, 'component', 'PenjadwalanKandidat');
      this.$set(this.formulir, 'tipe', 'detil');
      this.$set(this.formulir, 'info', Object.assign({}, this.pspSimulasi, this.detail.meta));
      this.$set(this.formulir, 'isPreview', true);
      this.$refs.dialog.open();

      this.$nextTick(() => {
        this.$refs.jadwal.reset();
        this.$set(this.formulir, 'title', 'Detil Jadwal Simulasi Wawancara');
      });
    },

    onKonfirmasi(value) {
      if (this.isTutup) {
        const msg = `<p class="title mb-2">Mohon maaf! anda telah melewati batas waktu konfirmasi yang telah ditentukan</p>`;
        this.$info(msg, `Konfirmasi tidak dapat dilakukan`, {
          tipe: 'warning',
          data: '',
        });
        return;
      }

      const id = this.$getDeepObj(this.pspProfil, 'psp_profil_id');
      const gelombang = this.$getDeepObj(this.pspProfil, 'gelombang');
      this.$refs.notifjadwal.open().then(() => {
        this.updateKonfirm({ id: id, params: { is_setuju_jadwal: value, gelombang: gelombang } }).then(() => {
          this.$success('Berhasil konfirmasi jadwal, silahkan menunggu sesi simulasi mengajar dimulai');
          this.getPreferensi(true);
        });
      });
    },

    async fetchRpp() {
      const resp = await this.getRpp({ id: this.$getDeepObj(this, 'pspProfil.psp_profil_id') }).then(
        ({ data }) => data
      );
      this.dataRpp = resp || [];
      return Promise.resolve(resp);
    },

    nextStep(item) {
      switch (item.value) {
        case 1:
          this.fetchRpp().then(() => {
            this.step++;
          });
          break;
      }
    },

    konfirmasiRpp() {
      if (!this.file_rpp) {
        this.$error('Harap pilih RPP terlebih dahul');
      }

      const params = {
        id: this.$getDeepObj(this.pspProfil, 'psp_profil_id'),
        name: 'konfirmasirpp',
        params: {
          id: this.file_rpp,
        },
      };

      this.updateRpp(params).then(() => {
        this.step++;
      });
    },

    toLink(link) {
      switch (link) {
        case 'rpp':
          window.open(this.$getDeepObj(this, 'config.guru-berbagi.url', '_blank'));
          break;
      }
    },

    async getProfil() {
      const resp = await this.fetchProfil({ id: this.$getDeepObj(this.pspProfil, 'psp_profil_id') });
      this.detail = Object.assign({}, resp.data, resp.meta);
      return Promise.resolve(resp);
    },

    setRpp(value) {
      const pspRpp = (value && value.psp_profil_rpps && value.psp_profil_rpps.data) || [];
      if (pspRpp.length && this.isKonfirmasi) {
        this.$set(this, 'file_rpp', pspRpp[0]['wp_id']);
        this.$set(this, 'step', 3);
      } else {
        this.$set(this, 'step', 1);
      }
    },

    onCall(item) {
      const url = `https://wa.me/62${Number(item)}`;
      window.open(url, '_blank');
    },
  },
};
